import React from "react";

interface AvatarProps {
    src?: string | null;
    name?: string;
    className?: string; // Tailwind size classes like "w-10 h-10"
}

const Avatar: React.FC<AvatarProps> = ({ src, name, className: size = "w-14 h-14" }) => {
    const getInitials = (fullName?: string): string => {
        if (!fullName || fullName.trim() === "") return "??";
        const names = fullName.trim().split(" ");
        const initials = names.map((n) => n[0]?.toUpperCase() || '');
        return initials.slice(0, 2).join("");
    };

    const isPlaceholder = !src || src.includes("no_image_employee.png");
    const initials = getInitials(name);

    return (
        <div className={`rounded-full flex items-center justify-center bg-gray-300 text-gray-800 font-medium ${size}`}>
            {isPlaceholder ? (
                <span>{initials}</span>
            ) : (
                <img src={src} alt={name || "User Avatar"} className={`rounded-full object-cover ${size}`} />
            )}
        </div>
    );
};

export default Avatar;
